import ActivityEventList from "./ActivityEventList";
import ActivityAlertMuteSettings from "./ActivityAlertMuteSettings";
import ActivityFeedControls from "./ActivityFeedControls";
import useActivityFilters from "../../hooks/useActivityFilters";
import usePriorityActivityAlerts from "../../hooks/usePriorityActivityAlerts";

export default function ActivityFeed({ items, onExportActivity, onExportLeads, onResend, onRefresh, resendingEntity, isRefreshing }) {
  const filters = useActivityFilters(items);
  const alerts = usePriorityActivityAlerts(items);
  const controlProps = {
    activePreset: filters.activePreset,
    dateRange: filters.dateRange,
    filter: filters.filter,
    isRefreshing,
    notificationPermission: alerts.notificationPermission,
    onEnableBrowserAlerts: alerts.enableBrowserAlerts,
    onToggleAlertMute: alerts.toggleAlertMute,
    onExportActivity,
    onExportLeads,
    onRefresh,
    onSelectPreset: filters.applyPreset,
    onSetDateRange: filters.setCustomDateRange,
    onSetFilter: filters.setCustomFilter,
    onSetQuery: filters.setCustomQuery,
    query: filters.query,
    mutedAlerts: alerts.mutedAlerts,
  };

  return (
    <section className="admin-section activity-section" data-testid="admin-activity-section">
      <div className="activity-heading">
        <div><span className="eyebrow">Live activity</span><h2>CONTROL ROOM FEED {alerts.newPriorityCount > 0 && <span className="activity-badge" data-testid="activity-notification-badge">{alerts.newPriorityCount}</span>}</h2></div>
        <span className="activity-count" data-testid="activity-event-count">{filters.filteredItems.length} recent events</span>
      </div>
      <ActivityFeedControls {...controlProps} />
      <ActivityAlertMuteSettings mutedAlerts={alerts.mutedAlerts} onToggleAlertMute={alerts.toggleAlertMute} />
      {alerts.newPriorityCount > 0 && <button className="activity-read-button" type="button" onClick={alerts.markAllRead} data-testid="mark-activity-read-button">Mark alerts read</button>}
      <ActivityEventList items={filters.filteredItems} onResend={onResend} resendingEntity={resendingEntity} />
    </section>
  );
}